export default __webpack_public_path__ + "static/media/vitaminD.794d8d45.svg";